import { css } from 'lit';
import { property } from 'lit/decorators.js';
import { createEventDescriptorMap } from './element-events';
import { createPropertyDescriptorMap, createPropertyProxy, } from './element-properties';
import { FunctionalElementBaseClass, } from './functional-element';
import { createRenderParams } from './render-callback';
const defaultInit = {
    events: {},
    props: {},
};
export function defineFunctionalElement(functionalElementInit) {
    var _a;
    const eventsMap = createEventDescriptorMap(functionalElementInit.events);
    const anonymousClass = (_a = class extends FunctionalElementBaseClass {
            constructor() {
                super();
                this.initCalled = false;
                this.instanceProps = createPropertyProxy(functionalElementInit.props, this);
                const initProps = functionalElementInit.props || {};
                Object.keys(initProps).forEach((propName) => {
                    const functionalElementInstance = this;
                    property()(functionalElementInstance, propName);
                    functionalElementInstance[propName] = initProps[propName];
                });
            }
            createRenderParams() {
                return createRenderParams(this, eventsMap);
            }
            render() {
                const renderParams = this.createRenderParams();
                if (!this.initCalled && functionalElementInit.initCallback) {
                    this.initCalled = true;
                    functionalElementInit.initCallback(renderParams);
                }
                return functionalElementInit.renderCallback(renderParams);
            }
        },
        _a.tagName = functionalElementInit.tagName,
        _a.styles = functionalElementInit.styles || css ``,
        _a.init = { ...defaultInit, ...functionalElementInit },
        _a.events = eventsMap,
        _a.renderCallback = functionalElementInit.renderCallback,
        _a.props = createPropertyDescriptorMap(functionalElementInit.props),
        _a);
    window.customElements.define(functionalElementInit.tagName, anonymousClass);
    return anonymousClass;
}
